import { KeyboardEvent } from 'react';

import { KEYBOARD } from 'src/constants/keyboard.constants';

export const handleSpaceClick = (e: KeyboardEvent<HTMLElement>) =>
  e.code === KEYBOARD.space.code ? e.currentTarget.click() : null;
